<template>
  <div
    class="login-modal-overlay"
    :class="{ active: visible }"
    @click.self="onClose"
  >
    <div class="login-modal" style="position:relative">
      <button class="login-modal-close" @click="onClose">×</button>
      <h3>{{ title }}</h3>
      <div class="login-modal-sub">{{ message }}</div>
      <div class="login-modal-error">{{ errorMsg }}</div>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>用户名</label>
          <input
            ref="usernameRef"
            v-model="username"
            type="text"
            placeholder="请输入用户名"
            autocomplete="username"
          >
        </div>
        <div class="form-group">
          <label>密码</label>
          <input
            v-model="password"
            type="password"
            placeholder="请输入密码"
            autocomplete="current-password"
          >
        </div>
        <button
          class="btn-login-modal"
          :disabled="submitting"
          type="submit"
        >登 录</button>
      </form>
      <div class="login-modal-contact">
        <img class="login-modal-qr" :src="wechatQr" alt="微信二维码">
        <div class="login-modal-contact-text">
          <div class="login-modal-contact-title">联系与演示</div>
          <div>微信：长按识别左侧二维码添加</div>
          <div>邮箱：<a href="mailto:yoyo@seqvec.com">yoyo@seqvec.com</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick } from 'vue'
import { usePortal } from '@/stores/portal'
import { globalToast } from '@/composables/useToast'
import wechatQr from '@/assets/wechat-qr.png'

const portal = usePortal()

const props = defineProps<{
  visible: boolean
  title?: string
  message?: string
}>()

const emit = defineEmits<{
  close: []
  loggedIn: []
}>()

const username = ref('')
const password = ref('')
const errorMsg = ref('')
const submitting = ref(false)
const usernameRef = ref<HTMLInputElement>()

watch(() => props.visible, (v) => {
  if (v) {
    username.value = ''
    password.value = ''
    errorMsg.value = ''
    nextTick(() => usernameRef.value?.focus())
  }
})

async function handleSubmit() {
  if (!username.value.trim() || !password.value) {
    errorMsg.value = '请输入用户名和密码'
    return
  }
  submitting.value = true
  errorMsg.value = ''
  try {
    await portal.login(username.value.trim(), password.value)
    emit('close')
    emit('loggedIn')
    globalToast('登录成功！', 'success')
  } catch (err: any) {
    errorMsg.value = err.message || '登录失败'
  } finally {
    submitting.value = false
  }
}

function onClose() {
  emit('close')
}
</script>
